export const environment = {
  production: false,
  apiUrl: 'https://dev-api.examally.com',
  enableLogging: true,
  version: '1.0.0',
  googleAnalyticsId: 'G-GJV6MM6FFH',

  // Supabase Configuration - Placeholder values for development environment
  // TODO: Replace with actual Supabase values when needed
  supabaseUrl: 'https://bmiugfiduckbcptslesn.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJtaXVnZmlkdWNrYmNwdHNsZXNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM1Mjk0NTQsImV4cCI6MjA2OTEwNTQ1NH0.RILTE915-Cgx05bslXeBhCle7-wZu6ZFABa4G5FFcnI'
};
